import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const MinusCircle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 25"
      fill={fill}
      {...rest}
    >
      <path
        d="M12.4199 22.5C17.9199 22.5 22.4199 18 22.4199 12.5C22.4199 7 17.9199 2.5 12.4199 2.5C6.91992 2.5 2.41992 7 2.41992 12.5C2.41992 18 6.91992 22.5 12.4199 22.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.41992 12.5H16.4199"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

MinusCircle.displayName = 'MinusCircle';
